import React from 'react';
import { motion } from 'framer-motion';
export function IsForYouSection() {
  const points = ['Quieres empezar en el mundo digital y no sabes cómo', 'Ya comenzaste pero te sientes estancada', 'Tienes un producto y no logras vender', 'Publicas sin estrategia ni claridad', 'Te cuesta mostrarte en redes', 'Consumes contenido pero no accionas', 'Necesitas dirección y acompañamiento real', 'Quieres construir ingresos digitales alineados contigo'];
  return <section className="py-24 bg-brand-brown-light text-brand-cream px-6" data-id="element-76">
      <div className="max-w-4xl mx-auto" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-serif mb-6 flex items-center justify-center gap-3" data-id="element-79">
            <span className="text-brand-gold text-2xl" data-id="element-80">🌷</span>
            Esta mentoría es ideal para ti si…
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-81">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4" data-id="element-82">
              <div className="w-1.5 h-1.5 rounded-full bg-brand-gold mt-2.5 shrink-0" data-id="element-83"></div>
              <span className="text-lg font-light text-brand-cream/90 leading-relaxed" data-id="element-84">
                {point}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}